export const field_component_mixin = {
    data(){
        return{

        }
    },
    computed:{
        error_message(){
            return this.$store.state.errors[this.$store.state.active_view][this.field_name] != undefined ? this.$store.state.errors[this.$store.state.active_view][this.field_name][0]:''
        },
        is_required(){
            return this.$store.state.stages[this.$store.state.active_view].fields[this.field_name].required
        }
    },
    methods:{

    },
    mounted(){

    }
}